import {getSelectedResidentialAddress} from '../selectors/selectors';
import doMetric from '../tracking/bigQueryMetricRecorder';
import Track from '../utils/tracking';

export default (deliveryData, getState) => {
  if (!window.dataLayer?.push || typeof window.dataLayer?.push !== 'function') return 'fail';
  
  const {order} = window.start;
  
  const partialResidentialPostcode = getSelectedResidentialAddress(getState())?.postCode?.split(' ')[0];
  
  try {
    const gtmDeliveryData = {
      event: 'homebase',
      orderInfo: order.basketItems.map((basketItem) => {
        const hkuId = basketItem.externalProductId || basketItem.productId;
        let unshippableGroupBasketItemBelongsToIfAny;
        let checkoutStatus;
        let externalProductStatus;
        let postcode;
        let storeName;
      
        const isFulfilmentMethodHomeDelivery = basketItem.fulfilmentMethod === 'HOME_DELIVERY';
        const isDeliveryOptionsResponseStatusTimeOut = deliveryData.deliveryOptionsResponseStatus === 'TIME_OUT';
        const isDeliveryOptionsResponseStatusSuccessfullDefault = deliveryData.deliveryOptionsResponseStatus === 'SUCCESSFUL_DEFAULT';
      
        if (isDeliveryOptionsResponseStatusSuccessfullDefault) {
          externalProductStatus = 'SUCCESSFUL_DEFAULT';
        } else if (!isDeliveryOptionsResponseStatusTimeOut) {
          if (!!deliveryData.unshippableGroups && deliveryData.unshippableGroups.length !== 0) {
            unshippableGroupBasketItemBelongsToIfAny = deliveryData.unshippableGroups.find(data => data.basketItems
              .find(item => item.id === basketItem.productId));
          
            const unshippableGroupBasketItem = unshippableGroupBasketItemBelongsToIfAny
              ?.basketItems.find(item => item.id === basketItem.productId);
          
            externalProductStatus = unshippableGroupBasketItem?.externalProductStatus;
            checkoutStatus = unshippableGroupBasketItemBelongsToIfAny?.unshippableReason;
          }
        } else {
          checkoutStatus = 'TIME_OUT';
        }
      
        if (isFulfilmentMethodHomeDelivery) {
          postcode = partialResidentialPostcode;
        } else {
          if (unshippableGroupBasketItemBelongsToIfAny) {
            const unshippableGroupBasketItem = unshippableGroupBasketItemBelongsToIfAny
              ?.basketItems.find(item => item.id === basketItem.productId);
            const store = unshippableGroupBasketItem?.store;
          
            storeName = store?.name;
            postcode = store?.postcode;
          } else {
            const filteredDeliveryGroup = deliveryData.deliveryGroups.find(data => data.basketItems
              .find(item => item.id === basketItem.productId));
            const firstDeliveryOptionForGroup = filteredDeliveryGroup?.deliveryOptions?.[0];
            const store = firstDeliveryOptionForGroup?.store;
          
            storeName = store?.name;
            postcode = store?.postcode;
          }
        
          if (!postcode || !storeName) {
            storeName = basketItem?.store?.name;
            postcode = basketItem?.store?.postcode;
          }
        }
      
        return {
          sku: hkuId || '',
          fulfillmentMethod: basketItem.fulfilmentMethod || '',
          storeName: storeName || '',
          postcode: postcode || '',
          deliveryServiceStatus: externalProductStatus || '',
          checkoutStatus: checkoutStatus || '',
        };
      }),
    };
    
    window.dataLayer.push(gtmDeliveryData);
  
    try {
      const orderInfoNoPostcode = gtmDeliveryData.orderInfo.map(basketItem => ({...basketItem, postcode: 'OBSCURED'}));
      const gtmDeliveryDataStringified = JSON.stringify({...gtmDeliveryData, orderInfo: orderInfoNoPostcode});
      doMetric('gtmPushDeliveryDataToCheckoutPage', [{name: 'deliveryData', value: gtmDeliveryDataStringified}], [], 'impression');
    } catch (e) {
      Track.track(e);
    }
  } catch {
    return 'fail';
  }
  
  return 'success';
};
